import { render, staticRenderFns } from "./AuthStatus.vue?vue&type=template&id=65a2fcf4&"
import script from "./AuthStatus.vue?vue&type=script&lang=ts&"
export * from "./AuthStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports